export default "__VITE_ASSET__DxZZkXzj__"